import { render, staticRenderFns } from "./TopsV2.vue?vue&type=template&id=aef86a1c&scoped=true&"
import script from "./TopsV2.vue?vue&type=script&lang=js&"
export * from "./TopsV2.vue?vue&type=script&lang=js&"
import style0 from "./TopsV2.vue?vue&type=style&index=0&id=aef86a1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aef86a1c",
  null
  
)

export default component.exports